import styled from 'styled-components';

export const DownloadButton = styled.button`
width:48%;
background-color:#FFFF;
border: 2px solid #454ADE;
box-sizing: border-box;
border-radius: 4px;
font-family: Nunito;
color: #454ADE;
outline:none;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 140%;
display:flex;
flex-direction:row;
justify-content:center;
align-items:center;
text-align:center;
`;

export const ShareButton = styled(DownloadButton)`
background: #454ADE;
color: #FFFFFF;
`;


export const ContainerDiv = styled.div`
  position:fixed;
  margin-top:56px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: black;
  height: 100vh;
  z-index:200;
`;

export const CopyImage = styled.img`
margin-top:2px;
margin-left:10px;
height=14px;
width=14px;
`;


export const ScannerToolbar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 56px;
  bottom: 0px;
  box-sizing:border-box;
  padding: 22px 24px 22px 24px;
  background: #1b1b1b;
  box-shadow: 0px -2px 14px rgba(0, 0, 0, 0.1);
  z-index: 90;
`;

export const DetailsContainerDiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  margin-top: 64px;
  background-color: #f3f3fd;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 500;
`;

export const DetailsToolbar = styled.div`
  position: fixed;
  bottom: 24px;
  width: 90%;
  margin-left: 5%;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FooterText = styled.div`
  position: static;
  height: 25.77px;
  margin-top: 32px;
  margin-bottom: 30px;
  width: 270px;
  margin-left: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #2ea472;
`;

export const InvalidCode = styled.div`
  position: fixed;
  height: 100vh;
  margin-top: 100px;
  width: 100vh;
  box-sizing:border-box;
  padding-left:10%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #2ea472;
  background-color:#FFFFFF;
  z-index:200;
`;

export const DetailDiv = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

export const Item = styled.div`
  width: 90%;
  margin-left: 10%;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content:flex-start;
  font-family: Nunito;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #303645;
  text-overflow: ellipsis;
`;

export const ItemLabel = styled.div`
width: 45%;
`;

export const NavImage = styled.img`
width:24px;
height:20px;
`;

export const QRErrorDiv = styled.div`
margin-top:35vh;
width: 269px;
height: 119px;
background: #FFFFFF;
border: 1px solid #CCCCCC;
padding-right:16px;
padding-bottom:16px;
box-sizing: border-box;
box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
border-radius: 5px;
z-index:500;
display:flex;
flex-direction:column;
justify-content:flex-start;
align-items:flex-end;
`;

export const QRImg = styled.img`
position:static;
`;

export const QRErrorBox = styled.div`
position:static;
height:57px;
width:229px;
margin-top:22px;
display:flex;
flex-direction:row;
justify-content:flex-start;
align-items:flex-start;
`;

export const QRErrorText = styled.span`
position:static;
height:57px;
margin-left:7px;
display:flex;
flex-direction:row;
justify-content:flex-start;
align-items:flex-start;
font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 19px;
letter-spacing: 0.15px;
color: #1A1A1A;
`;

export const ScanAgain = styled.button`
position:static;
margin-top:2px;
border:none;
height: 22px;
outline:none;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 22px;
letter-spacing: 0.15px;
color: #454ADE;
background-color:#FFFF;
outline:none;
`;

export const BtnIcons = styled.img<{
  margin:number
}>`
margin-left:-${props=>props.margin}px;
`;